module.exports = {"340802001":"宜城路街道","340802002":"新河路街道","340802003":"华中路街道","340802004":"人民路街道","340802005":"孝肃路街道","340802006":"滨江街道","340802200":"龙狮桥乡","340802201":"长风乡","340802202":"新洲乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/340802.json
// module id = 1090
// module chunks = 0